import { styled } from "@compiled/react";

import { Picture } from "../../components";
import { UiImageModel } from "../../models";

export type UiImageProps = {
    readonly model: UiImageModel;
};

const UiImage = ({
    model: {
        content: { image, altText, decorative }
    }
}: UiImageProps) => {
    return (
        <StyledImage image={image} altText={altText} decorative={decorative} />
    );
};

const StyledImage = styled(Picture)({
    margin: "0 0 1rem"
});

export default UiImage;
